import {ApartmentModel} from "features/apartmentViewer/ApartmentViewer/models/ApartmentModel";
import {ApiSiteModel} from "features/apartmentViewer/types";
import {ThumbNailModel} from "features/apartmentViewer/ApartmentViewer/models/ThumbNailModel";
import {FurnishingModel} from "features/apartmentViewer/ApartmentViewer/models/FurnishingModel";

export class SiteModel {
    private _currentApartment: ApartmentModel | undefined;
    private _currentFurnishing: string;
    private _thumbNails: ThumbNailModel[] | undefined;
    private _furnishings: FurnishingModel[] | undefined;
    private _stageId: string;
    private _stageUrl: string;
    private _activeViews: string[] | undefined;

    constructor(siteModel: ApiSiteModel) {
        this.setupApartmentData(siteModel);

        const defaultApartmentData = this.getDefaultFurnishedApartment(siteModel);

        this._currentFurnishing = defaultApartmentData.archetypeId;
        this._stageId = siteModel.stageId;
        this._stageUrl = siteModel.stageUrl;

    }

    setupApartmentData(siteModel: ApiSiteModel) {
        const defaultApartmentData = this.getDefaultFurnishedApartment(siteModel);

        if(!defaultApartmentData) return;

        this._currentApartment = new ApartmentModel(defaultApartmentData.apartment);
        this._thumbNails = defaultApartmentData.thumbs.cameras.map(thumbNail => new ThumbNailModel(thumbNail));
        this._furnishings = siteModel.config.archetypes.map(furnishing => new FurnishingModel(furnishing));
        this._activeViews = Object.keys(siteModel.views);
    }

    getDefaultFurnishedApartment(siteModel: ApiSiteModel) {
        return siteModel.views[siteModel.config.defaultArchetypeId] ?? siteModel.views[Object.keys(siteModel.views)[0]];
    }

    get currentFurnishing(): string {
        return this._currentFurnishing;
    }

    set currentFurnishing(value: string) {
        this._currentFurnishing = value;
    }

    get currentApartment(): ApartmentModel | undefined {
        return this._currentApartment;
    }

    set currentApartment(value: ApartmentModel) {
        this._currentApartment = value;
    }

    get thumbNails(): ThumbNailModel[] | undefined {
        return this._thumbNails;
    }

    set thumbNails(value: ThumbNailModel[]) {
        this._thumbNails = value;
    }

    get stageUrl(): string {
        return this._stageUrl;
    }

    set stageUrl(value: string) {
        this._stageUrl = value;
    }
    get stageId(): string {
        return this._stageId;
    }

    set stageId(value: string) {
        this._stageId = value;
    }

    get furnishings(): FurnishingModel[] | undefined {
        return this._furnishings;
    }

    set furnishings(value: FurnishingModel[]) {
        this._furnishings = value;
    }

    get activeViews(): string[] | undefined {
        return this._activeViews;
    }

    set activeViews(value: string[]) {
        this._activeViews = value;
    }

}
